/* ============================================================
   ASHLEY JADE LTD — GLOBAL.JS
   Site-wide JavaScript loaded on every page.
   ============================================================ */

(function () {
  'use strict';

  // Honour reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- SCROLL REVEALS ----------
  const revealElements = document.querySelectorAll('.reveal, .reveal-stagger');

  if (revealElements.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -80px 0px',
      }
    );

    revealElements.forEach((el) => observer.observe(el));
  } else {
    // Fallback: just show everything
    revealElements.forEach((el) => el.classList.add('is-visible'));
  }

  // ---------- SCROLL PROGRESS BAR ----------
  const progressBar = document.createElement('div');
  progressBar.className = 'scroll-progress';
  document.body.appendChild(progressBar);

  let ticking = false;

  function updateProgress() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressBar.style.width = progress + '%';
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    },
    { passive: true }
  );

  // ---------- BODY SCROLL LOCK (used by mobile menu) ----------
  window.AJ = window.AJ || {};
  window.AJ.lockScroll = function () {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = window.innerWidth - document.documentElement.clientWidth + 'px';
  };
  window.AJ.unlockScroll = function () {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };
})();
